import { mock, instance, verify, when, anyNumber, anything, resetCalls } from 'ts-mockito';
import * as moment from 'moment';
import { State } from '../../services/global-state';
import { ScheduledPayments } from './scheduled-payments';
import { Customer, Account } from '../../models/customer';
import { PayrazrService } from '../../services/payrazr';
import { Router } from 'aurelia-router';
import { Business } from '../../models/business';

describe('NewPortalWeb', () => {
	describe('pages', () => {
		describe('scheduled-payments', () => {
			let component: ScheduledPayments;
			const mockState: State = mock(State);
			const mockBusiness: Business = mock(Business);
			const mockRouter: Router = mock(Router);
			const mockCustomer: Customer = mock(Customer);
			const mockPayrazr: PayrazrService = mock(PayrazrService);

			// Initialize Component
			beforeEach(() => {
				const accounts = [
					{
						displayName: 'testAccount',
						paymentPlans: [
							{
								payments: [
									{
										paymentDate: new Date('01/01/2020'),
										paymentAmount: 5000
									}
								],
								paymentInstrument: {
									paymentType: 'testType',
									paymentAccount: 'testAccount'
								}
							}
						]
					}
				];

				when(mockCustomer.accounts).thenReturn(accounts as Account[]);
				when(mockState.accounts).thenReturn(accounts as Array<Account>);
				when(mockState.business).thenReturn(instance(mockBusiness));
				when(mockBusiness.fetchPortfolioSettings(anything)).thenReturn({
					settings: {
						paymentTypes: {

						}
					}
				});
				component = new ScheduledPayments(
					instance(mockState),
					instance(mockPayrazr),
					instance(mockRouter)
				);
			});

			it('should initialize component', () => {
				expect(component).toBeTruthy();
				expect(component.isLoading).toBeTruthy();
			});

			describe('loadSchedules()', () => {

				it('should get all payments from global state', () => {
					component.loadSchedules();
					expect(component.scheduledPayments.length).toEqual(1);
					expect(component.isLoading).toBeFalsy();
					expect(component.nextPayment).toEqual(moment(new Date('01/01/2020')));
				});
			});
		});
	});
});
